import {
  AddDataLayerPayload,
  BizPropertyPayload,
  LogEventWidthGroupsPayload,
  UserPropertiesPayload,
  UserPropertyPayload,
} from './types'

import {ModuleFc} from '@/project'

const module: ModuleFc<any, any> = () => ({
  namespaced: true,
  actions: {
    logEventWithGroups({rootState, dispatch}, payload: LogEventWidthGroupsPayload) {
      const {
        event = 'logEventWithGroups',
        eventType, eventProperties,
      } = payload || {}
      dispatch('_addDataLayer', {
        event,
        eventType,
        groupType: 'biz_id',
        groupName: rootState?.biz?.id,
        eventProperties,
      })
    },
    setUserProperties({dispatch}, payload: UserPropertiesPayload) {
      dispatch('_addDataLayer', payload)
    },
    setUserProperty({dispatch}, payload: UserPropertyPayload) {
      const {userProperty, event} = payload
      Object.keys(userProperty).forEach((propertyName) => {
        dispatch('_addDataLayer', {
          event,
          userProperty: {name: propertyName, value: userProperty[propertyName]}
        })
      })
    },
    setBizProperty({rootState, dispatch}, payload: BizPropertyPayload) {
      const {event, bizProperty} = payload

      const groupEventDict = {
        setBizProperty: 'setGroupProperty',
        setOnceBizProperty: 'setOnceGroupProperty',
        addBizProperty: 'addGroupProperty',
      }

      Object.keys(bizProperty).forEach((propertyName) => {
        dispatch('_addDataLayer', {
          event: groupEventDict[event],
          groupType: 'biz_id',
          groupName: rootState?.biz?.id,
          groupProperty: {name: propertyName, value: bizProperty[propertyName]},
        })
      })
    },
    _addDataLayer(_, payload: AddDataLayerPayload) {
      // @ts-ignore
      if(window.dataLayer) {
        // @ts-ignore
        window.dataLayer.push(payload)
      }
    },
  },
})

export default module
